<div class="header-container">

    <div class="row">
        <div class="reservation-header" *ngIf="reservation.id">
            <span class="job-card">#{{reservation.reservationNumber}}</span>
            <span class="status">{{reservation.reservationStatus}}</span>
            <span class="customer">{{reservation.firstName}} {{reservation.surname}}</span>
        </div>
        <div class="reservation-header" *ngIf="!reservation.id">
            <span class="job-card">#{{reservationSummary.reservationNumber}}</span>
            <span class="status">{{reservationSummary.reservationStatus}}</span>
            <span class="customer">{{reservationSummary.customer}}</span>
        </div>
    </div>


    <div class="reservation-tab-container" *ngIf="reservation && reservation.id">
        <p-tabMenu [model]="reservationItems" [activeItem]="activeItem"></p-tabMenu>
        <div class="fa hubtiger-print font-button" (click)="printReservation()"></div>
    </div>
</div>

<div class="content-container">
    <div *ngIf="selectedTab===0">
        <div *ngIf="!reservation.id || !cyclist.ID" style="margin-top: 32px;display: flex;justify-content: center;">
            <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
            </p-progressSpinner>
        </div>
        <div *ngIf="reservation.id && cyclist.ID">
            <app-rental-reservation-job-card [partner]="partnerData" [cyclist]="cyclist" [reservation]="reservation"
                [reservationPaymentHistory]="reservationPaymentHistory"
                (updateReservationData)="updateReservationData($event)" [fullAccessoryList]="fullAccessoryList"
                [categories]="categories" [brands]="brands" [sizes]="sizes" [rentalStoreRules]="rentalStoreRules"
                [affiliates]="affiliates"></app-rental-reservation-job-card>
        </div>
    </div>
    <div *ngIf="selectedTab===1">
        <app-rental-reservation-quote [partner]="partnerData" [reservation]="reservation"
            [reservationPaymentHistory]="reservationPaymentHistory"
            (reloadReservation)="reloadReservation($event)"></app-rental-reservation-quote>
    </div>
    <div *ngIf="selectedTab===2">
        <app-rental-reservation-messaging [reservation]="reservation"></app-rental-reservation-messaging>
    </div>
    <div *ngIf="selectedTab===3">
        <app-rental-reservation-checklist [reservation]="reservation"></app-rental-reservation-checklist>
    </div>
    <div *ngIf="selectedTab===4">
        <app-rental-reservation-waiver [reservation]="reservation"
            [rentalStoreRules]="rentalStoreRules"></app-rental-reservation-waiver>
    </div>
</div>